<template>
    <div ref="qrCodeUrl" class="qrcode"></div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
    name: "QrCode",
    props: {
        url: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    watch: {
        url() {
            this.creatQrCode();
        }
    },
    mounted() {
        this.creatQrCode();
    },
    methods: {
        creatQrCode() {
            this.$refs.qrCodeUrl.innerHTML = ""; // 词句代码将之前的二维码清空了
            const qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: this.url, // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H
            });
        }
    }
};
</script>

<style></style>
